import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import AdminLayout from "layouts/admin";
import VendorLayout from "layouts/vendor"
import AuthLayout from "layouts/auth";
const App = () => {
  return (
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="admin/*" element={<AdminLayout />} />
      <Route path="vendor/*" element={<VendorLayout />} />
       <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />

      {/* Fallback for undefined routes, redirect to login */}
      <Route path="*" element={<Navigate to="/auth/sign-in" replace />} />
    </Routes>
  );
};

export default App;
